"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _components = require("@sart/components");
var _icons = require("@sart/icons");
var _styles = require("@sart/styles");
var _excluded = ["text", "open", "style", "color", "fontSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CollapsibleTitle = function CollapsibleTitle(props) {
  var text = props.text,
    open = props.open,
    style = props.style,
    color = props.color,
    fontSize = props.fontSize,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [style, defaultStyles.view]
  }, open && open === "plus" && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_icons.SquaredPlus, null), /*#__PURE__*/_react["default"].createElement(_components.Space, {
    width: 8
  })), open && open === "minus" && /*#__PURE__*/_react["default"].createElement(_icons.SquaredMinus, null), _objectSpread({}, text) && /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: {
      color: color,
      fontSize: fontSize
    }
  }, text), open && open === "down" && /*#__PURE__*/_react["default"].createElement(_icons.TriangleDown, null), open && open === "right" && /*#__PURE__*/_react["default"].createElement(_icons.TriangleRight, null));
};
CollapsibleTitle.defaultProps = {
  text: 'CollapsibleTitle',
  open: false,
  color: "#FF69B4"
};
var defaultStyles = _reactNative.StyleSheet.create({
  view: {
    justifyContent: 'space-between',
    flexDirection: 'row'
  }
});
var _default = exports["default"] = CollapsibleTitle;